<template>
  <div class="container-lg">
    <div class="car-base skip car-book">
      <div class="mid-title" v-show="!success">
        <h1>预约试驾</h1>
        <div style="width:100%;margin-bottom: 3px;" flex="main:center">
          <div style="border-bottom: 1px solid;width: 100%;border-color:#dad9de"></div>
        </div>
        <div class="tit br-con" style="letter-spacing: 0;font-size:14px;color:#333;font-weight: normal;margin-bottom: 0.4rem;margin-top: .1rem;">欢迎您在线申请预约试驾，请在下方填写您的联络信息
        </div>
      </div>
      <div class="book_wrap clearfix">
        <div class="pull-left car-form" style="width:100%">
          <div class="drive-base ng-isolate-scope" :username="dforms.userName" :gender="dforms.gender"
               :success="success" v-show="!success">
            <div class="box">
              <label class="title">您的详细信息</label>
              <div class="group">
                <div class="w50">
                  <input id="nissan_qashqai_lbanner_yysj_name"
                         style="outline: none;box-shadow: none;"
                         class="inputs form-control ng-isolate-scope ng-pristine ng-valid" type="text"
                         v-model="dforms.userName" placeholder="姓名">
                </div>
                <div class="w50" style="display:flex">
                  <label class="radio-inline"
                         :class="{active: (dforms.gender === '1'||dforms.gender === undefined ) ? true : false}" style="display: flex;align-items: center;">
                    <input id="nissan_qashqai_lbanner_yysj_male" type="radio" name="sex" v-model="dforms.gender"
                           value="1" class="ng-pristine ng-valid">先生
                  </label>
                  <label class="radio-inline" :class="{active: (dforms.gender === '2') ? true : false}" style="display: flex;align-items: center;">
                    <input id="nissan_qashqai_lbanner_yysj_female" style="outline: none;box-shadow: none;" type="radio"
                           name="sex" v-model="dforms.gender" value="2" class="ng-pristine ng-valid">女士
                  </label>
                </div>
              </div>
              <div class="group">
                <input id="nissan_qashqai_lbanner_yysj_phone"
                       style="outline: none;box-shadow: none;"
                       class="inputs form-control ng-isolate-scope ng-pristine ng-invalid ng-invalid-required"
                       type="text" v-model="dforms.phoneNbr" required="" placeholder="电话">
              </div>
            </div>

            <div class="box select_box">
              <label class="title">试驾预约</label>
              <div class="group">
                <div class="w50">

                  <div class="btn-group bootstrap-select selectProvince" id="nissan_qashqai_lbanner_yysj_province"
                       :class="{'dropup': this.min}">
                    <button @click="showAll(1,$event)" type="button" class="btn dropdown-toggle btn-default"
                            data-toggle="dropdown" role="button" :title="dforms.province">
                      <span class="filter-option pull-left">{{dforms.provinceName}}</span>&nbsp;
                      <span class="bs-caret"><span class="icon icon-down mycaret"
                                                   style="vertical-align: baseline!important;width: auto;height: auto;"></span></span>
                    </button>
                    <div class="dropdown-menu" role="combobox" :class="choose_province ? 'open':''"
                         style="height:auto;overflow:auto">
                      <ul class="dropdown-menu inner" role="listbox" aria-expanded="false">
                        <li data-original-index="0" class="disabled">
                          <a tabindex="-1" class="" data-tokens="null" role="option"  aria-disabled="true"
                             aria-selected="false">
                            <span class="text">省份</span><span class="glyphicon glyphicon-ok check-mark"></span>
                          </a>
                        </li>
                        <li v-for="(item,index) in provinces" @click="choiceProvince(index+1,item)">
                          <a tabindex="0" class="ng-binding ng-scope" data-tokens="null" role="option"
                             aria-disabled="false" aria-selected="false">
                            <span class="text">{{item.name}}</span><span
                            class="glyphicon glyphicon-ok check-mark"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <!-- <select id="nissan_qashqai_lbanner_yysj_province"  selectpicker="" class="selectpicker selectProvince"  v-model="dforms.province" @change="choiceProvince()" tabindex="-98">
                      <option value="" disabled="">省份</option>
                      <option  v-for="(item,index) in provinces" class="ng-binding ng-scope" value="index">{{item}}</option>
                    </select> -->
                  </div>
                </div>

                <div class="w50">
                  <div class="btn-group bootstrap-select selectCity ng-pristine ng-valid"
                       id="nissan_qashqai_lbanner_yysj_city" :class="{'dropup': this.min}">
                    <button type="button" class="btn dropdown-toggle btn-default" data-toggle="dropdown" role="button"
                            :title="dforms.city" @click="showAll(2,$event)">
                      <span class="filter-option pull-left ng-binding">{{dforms.cityName}}</span>&nbsp;
                      <span class="bs-caret"><span class="icon icon-down mycaret"
                                                   style="vertical-align: baseline!important;width: auto;height: auto;"></span>
                      </span>
                    </button>
                    <div class="dropdown-menu" role="combobox" style="height:auto;overflow:auto"
                         :class="choose_city ? 'open':''">
                      <ul class="dropdown-menu inner" role="listbox" aria-expanded="false" style="overflow:auto">
                        <li data-original-index="0" class="disabled">
                          <a tabindex="-1" class="" data-tokens="null" role="option"  aria-disabled="true"
                             aria-selected="false">
                            <span class="text">城市</span><span class="glyphicon glyphicon-ok check-mark"></span>
                          </a>
                        </li>
                        <li v-for="item in CityInfoList" @click="choiceCity(item)">
                          <a class="ng-binding ng-scope" data-tokens="null" role="option" aria-disabled="false"
                             aria-selected="true">
                            <span class="text">{{item.Name}}</span><span
                            class="glyphicon glyphicon-ok check-mark"></span>
                          </a>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>

              <div class="group select_store">
                <div class="btn-group bootstrap-select" id="nissan_qashqai_lbanner_yysj_dealer"
                     :class="{'dropup': this.min}">
                  <button type="button" @click="showAll(3,$event)"
                          class="btn dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button"
                          data-id="nissan_qashqai_lbanner_yysj_dealer" title="选择专营店">
                    <span class="filter-option pull-left ng-binding">{{dforms.dealerName}}</span>&nbsp;
                    <span class="bs-caret"><span class="icon icon-down mycaret"
                                                 style="vertical-align: baseline!important;width: auto;height: auto;"></span></span>
                  </button>
                  <div class="dropdown-menu" role="combobox" :class="choose_dealer ? 'open':''"
                       style="height: auto;overflow: hidden auto">
                    <ul class="dropdown-menu inner" role="listbox" aria-expanded="false"
                        style="width:100%;height: auto;overflow: auto">
                      <li data-original-index="0" class="disabled selected">
                        <a tabindex="-1" class="" data-tokens="null" role="option"  aria-disabled="true"
                           aria-selected="true">
                          <span class="text">专营店</span><span class="glyphicon glyphicon-ok check-mark"></span>
                        </a>
                      </li>
                      <li v-for="(item,index) in dealerInfos" @click="choiceDealer(item)"
                          @mouseenter="mouseover(item,index)">
                        <a role="option" aria-disabled="false" aria-selected="true">
                          <span class="text">{{item.StoreName}}</span><span
                          class="glyphicon glyphicon-ok check-mark"></span>
                        </a>
                      </li>

                    </ul>

                    <!--                   <div class="storeWrap" v-show="showStoreDetail" style="height:100%;overfkow:hidden auto">-->
                    <!--                      <div class="storeDetail">-->
                    <!--                         <div class="sname"><span class="icon icon-local"><b>{{currentDealerInfo.index}}</b></span>{{currentDealerInfo.StoreName}}</div>-->
                    <!--                         <div class="sbox">-->
                    <!--                         <div class="stitle">电话：</div>-->
                    <!--                         <div class="stit">{{currentDealerInfo.SaleTel}}</div>-->
                    <!--                         <div class="stitle">地址：</div>-->
                    <!--                         <div class="stit">{{currentDealerInfo.Address}}</div>-->
                    <!--                         </div>-->
                    <!--                         </div></div> -->
                  </div>

                </div>
              </div>
            </div>


            <div class="group address" v-show="showAddress"><p class="ng-binding"><i class="icon icon-local"></i>{{currentDealerInfo.Address}}
            </p></div>
            <div class="group protocol">
              <div class="checkbox" style="margin:0;padding:0">
                <label class="radio-inline checkbox-inline " :class="{active:protocol}">
                  <input id="nissan_qashqai_lbanner_yysj_agree" type="checkbox" v-model="protocol" value="true"
                         checked="" class="ng-pristine ng-valid"> 我仔细阅读了并接受所附的 </label>
                <span id="nissan_qashqai_lbanner_yysj_check" @click="clickYinshi()">隐私条款</span>
              </div>
            </div>
            <div class="group button test_drive" flex="main:center">
              <div class="btn btn-primary" style="background: rgb(195,0,47);color:#fff;border-radius: 0;padding:8px 12px" flex="main:center"
                   @click="submitBtn()"><span class="pull-left">立即预约</span></div>
            </div>
          </div>
        </div>

        <div class="suc-wrap ng-isolate-scope" username="dforms.userName" gender="dforms.gender" v-show="success">
          <div class="suc-content">
            <img :src="path+'static/images/pc/right.png'" style="margin-top:1.44rem;margin-bottom:0.7rem;width:2rem;height:2rem;">
            <div class="tit" style="text-align: center;">谢谢！您的信息已提交成功</div>
            <div class="txt " style="white-space:unset;text-align: center;" v-show="dforms.gender === '1'">尊敬的 <span class="ng-binding" style="display: inline-block">{{dforms.userName}}</span>
              先生，您的试驾预约已成功提交，<br>我们将会在24小时内安排客服人员与您联系。
            </div>
            <div class="txt" v-show="dforms.gender === '2'">尊敬的 <span class="ng-binding">{{dforms.userName}}</span>
              女士，您的试驾预约已成功提交，<br>我们将会在24小时内安排客服人员与您联系。
            </div>
          </div>
        </div>
      </div>
    </div>

    <m-alert ref="alert">
      <div class="base_layer protection_layer layui-layer-wrap" style="display: block;">
        <div class="tit">隐私条款</div>
        <div class="txt">
          <div class="wrap">
            <p><strong>东风日产用户个人信息保护基本方针</strong></p>
            <p>东风日产乘用车公司严格遵守个人信息保护相关的中国法律法规，妥善处理顾客个人信息，遵守维护国家网络信息安全、保护个人用户隐私信息是企业重要的社会责任。基于此，“东风日产乘用车公司”制定了如下的保护个人信息基本方针。</p>
            <p><strong>用户须知</strong></p>
            <p>东风日产乘用车公司通过本网站（以下简称“网站”）将依据本隐私政策和相关国家法律规定收集、使用和披露用户个人信息，用户在浏览网站以及使用网站的特定服务之前，务必仔细阅读本隐私政策。用户一旦使用本网站，即表示用户理解并同意地接受本声明，用户应严格遵守本声明和相关法律的规定，如果用户不同意该申明或条款，则需停止浏览访问网站或停止提交相关服务功能申请。</p>
            <p><strong>知识产权声明</strong></p>
            <p>网站提供的内容或服务中包含的全部信息（包括但不限于任何文本、图片、音频、视频、数据、标识、数据编辑、商标）以及为提供服务而使用的任何软件均受知识产权和相关法律保护。用户不得以任何方式将网站信息用于其它商业用途。用户以个人和非商业目的使用网站内容或服务的情况除外。</p>
            <p>本网站转载内容并不代表东风日产（包括东风日产关联企业）认同该观点或证实其内容的真实性。东风日产乘用车公司不对这些第三方的内容或者链接做出任何保证或承担任何责任，用户应对本网站提供的第三方内容或通往第三方网站的链接自行加以判断，并承担因使用而引起的所有风险。本网站对于第三方内容展示有在提醒或说明内容来源的义务。</p>
            <p><strong>隐私声明</strong></p>
            <p>用户浏览本网站的一般性内容时，不要求提供任何个人信息。用户使用或浏览网站的特定服务或信息时（例如试驾申请、联系本网、参与活动），在用户同意并确认的基础上，东风日产可能会以线上或线下注册表格的形式要求用户提供如下个人资料和信息：</p>
            <ul>
              <li>一般信息：性别、年龄、职业、出生日期、教育程度、收入状况、婚姻家庭状况、兴趣爱好；</li>
              <li>联络信息：姓名、电子邮箱、电话号码、传真号码、手机号码、通讯地址；</li>
              <li>敏感信息：在需要用户付费才能享有的服务或产品，或参加本网站参与或组织的活动类似特定情况下，东风日产会要求用户提供信用卡号码、银行卡号码、身份证或护照号码个人付款信息和身份证件信息。</li>
            </ul>
            <p>网站自动收集的信息。不管用户是否注册或登录，东风日产可能会自动收集浏览本网站的用户的如下信息：</p>
            <ul>
              <li>用户浏览器类型、操作系统类型、宽带类型、浏览器语言；</li>
              <li>用户IP地址及该地址可能显示的用户地理位置；</li>
              <li>用户在本网站内浏览过的页面、广告和链接；</li>
              <li>用户访问本网站时发出的访问请求及其日期、时间和引荐网址（如有）；</li>
              <li>通过Cookie标注用户的浏览器的唯一性和在本网站的账户信息（包括用户访问本网站的各项活动、浏览习惯、消费习惯、账户信息）；用户可以选择修改浏览器设置拒绝cookie，如果用户拒绝了cookie，此时用户可能无法使用依赖于cookie才能提供的本网站服务或功能；</li>
              <li>东风日产可能会使用浏览器网络存储（包括 HTML 5）和应用程序数据缓存等机制，在用户设备上收集和存储用户所浏览过的网页信息；用户可自主选择拒绝；</li>
              <li>当用户使用本网站提供的具有定位功能的服务时，东风日产可能会收集并处理有关用户实际所在位置的信息，还可能使用其它技术进行定位。</li>
            </ul>
            <p>我们会采取合理可行的措施，避免收集无关的个人信息。<b>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求</b>，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：</p>
            <ul>
              <li>1、完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；</li>
              <li>2、保证我们为您提供服务的安全和质量；</li>
              <li>3、您是否同意更长的留存期间；</li>
              <li>4、是否存在保留期限的其他特别约定。</li>
            </ul>
            <p style="text-decoration: underline;"><b>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</b></p>
            <br>
            <p><strong>我们如何使用Cookie</strong></p>
            <p>为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储Cookie、Flash Cookie，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（统称“Cookie”）。
              您可以通过浏览器的设置功能，选择“不接受「Cookies」”的选项，防止「Cookies」储存在您的计算机上。要查明「Cookies」是如何在您的计算机上工作，请参阅浏览器制造商的说明。</p>
            <br>
            <p><strong>信息的使用</strong></p>
            1）关于个人信息的使用
            东风日产乘用车公司取得的个人信息，在符合国家相关法律法规条件下，企业正常经营及运营管理目的下使用：
            <ol>
              <li>1.与顾客进行的交易；</li>
              <li>2.根据用户的要求向用户提供特定服务、产品或信息；</li>
              <li>3.授权用户参加一项活动，例如线下活动招募、网上论坛或优惠抽奖等；</li>
              <li>4.商品及服务的企划、开发、改善；</li>
              <li>5.为改进网站的服务分析用户对本网站的使用方式和使用习惯；</li>
              <li>6.发送与“东风日产”的产品、服务、宣传活动（包括但不限于汽车、保险等）相关的信息或通知；但用户有权拒绝该商业或服务信息的推送；</li>
              <li>7.提高服务质量及顾客满意度等方面，实施的各项调查；</li>
              <li>8.顾客问询、联系“东风日产经销商”及东风日产顾客服务中心时，进行迅速的对应；</li>
              <li>9.根据法律规定或政府机关、法院、调解机构、仲裁机构等的通知、指导等而采取的对应；</li>
              <li>10.其他取得个人信息时所明示的使用目的。</li>
            </ol>
            2）向第三方提供个人信息
            东风日产使用安全制度、安全技术和其他措施防止用户的个人资料丢失、被盗用或遭篡改。个人信息不会用于未经同意或者说明的其他用途向第三方披露。用户理解并同意条件下，我方向第三方分享个人信息。
            <ol>
              <li>1.取得用户同意后，东风日产与第三方商业伙伴分享用户的个人信息；</li>
              <li>2.第三方合作伙伴在用户通过网站申请参加线上或线下活动，用户的个人信息可能会提供给相关第三方。</li>
              <li>3.获得用户同意后，授权登录其他第三方业务系统、数字平台时，可能会将用户识别信息披露第三方；</li>
            </ol>
            3）妥善管理个人信息
            <p>东风日产承诺会使用各种信息安全制度、安全技术和程序措施来尽量保护用户的个人信息不被未经授权地访问、使用或泄露。</p>
            <p><strong>信息使用范围</strong></p>
            <p>用户同意东风日产乘用车公司可以通过以下方式对个人信息进行使用和披露（包含对于个人信息的存储和处理）：</p>
            <ol>
              <li>1.我们（包含东风日产及分支机构、经销商、网上商城、自营自媒体平台、其他数字服务平台等）自行使用；</li>
              <li>2.我们向关联公司（包括但不限于东风日产乘用车附属公司、控股公司、多层级母公司、多层级子公司、联营公司、广告代理公司等）披露并由其使用；</li>
              <li>3.我们向相关东风日产特约店披露并由其使用；</li>
              <li>4.我们及关联公司及相关东风日产特约店为满足您的需求，通过您提供的信息与您联系；</li>
              <li>5.我们及关联公司及相关东风日产特约店会定期或不定期向您发送有关产品、服务或相关活动的信息并在推送时标明定向推送。</li>
            </ol>
            <p>您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。</p>
            <p><strong>我们的授权合作伙伴包括以下类型：</strong></p>
            <p>1. 广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。<br>2. 供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。<br>我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
            <p><strong>用户发布的信息</strong></p>
            <p>本网站的部分服务中，用户有权在遵守本网站申明的前提下，发布自己的信息、视频、照片、观点、评论、商品使用体验、商品讨论等，该等内容自发布之时起成为公开信息，同时，用户在本网站发布信息的行为即视为允许本网站对该等信息无偿拥有使用权和完全再许可的权利，且该等权利不受适用范围、任何时间和空间的限制，用户应于发布联系信息、财务信息或其他个人信息之前自行谨慎判断。用户发布上述内容使之成为公开信息后，东风日产对其风险概不负责。用户发布信息须符合国家互联网相关法律法规要求、内容文明健康、符合道德伦理、发布信息真实等基本要求，东风日产基于网站运营管理有权公开、屏蔽、删除用户发布信息，有权冻结用户服务账户而不必额外通知用户。</p>
            <p><strong>未成年人的信息保护</strong></p>
            <p>如您为未成年人，建议请您的父母或监护人阅读本政策，并在征得您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息。如您为未成年人的父母或监护人，当您对您所监护的未成年人的信息处理存在疑问时，请通过下文中客服中心的联系方式联系我们。<br>根据《儿童个人信息网络保护规定》，如监护人要求删除儿童个人信息，可以通过下文中客服中心的联系方式联系我们，系统后台在收到监护人要求后进行信息删除。</p>
            <p><strong>问询、访问、更正、删除、撤回、注销账户</strong></p>
            <p>关于个人信息的相关问询、访问、更正、删除、撤回、注销账户，请联系东风日产客服中心。如您发现我们收集、使用您个人信息的行为，违反了法律法规规定或违反了与您的约定，您可以要求我们删除相应的信息。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。当您符合约定的账户注销条件并注销账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或对外提供与该账户相关的个人信息，但您在使用网站期间提供或产生的信息我们仍需按照监管要求的时间进行保存，且在该保存的时间内依法配合有权机关的查询。“东风日产”将严格遵守个人信息保护相关的中国法律法规，进行妥善处理。</p>
            <p><strong>东风日产客服中心</strong></p>
            <p>【电话：800-830-8899，400-830-8899】</p>
            <p><strong>遵纪守法与改善以及更新与通知</strong></p>
            <p>“东风日产”将严格遵守个人信息保护相关的中国法律法规，并为了妥善处理个人信息而进行持续性的改善，并会将改善内容随时体现在本基本方针中，由于产品和服务的变化，申明的版本和内容也需不断更新，请用户注意并理解内容的更新。</p>
            <p><strong>数据安全责任人</strong></p>
            <p>我们努力为用户的信息安全提供保障，以防止信息的丢失，不当使用、未经授权访问或批露；我们建立专门的管理制度、流程和组织以保障数据安全；东风日产数据安全反馈邮箱customercare@dfl.com.cn，联系电话400-830-8899。</p>
          </div>
        </div>
        <div class="layer-close-btn icon icon-close" @click="$refs.alert.hide()"></div>
      </div>
    </m-alert>

    <v-drawer ref="drawer" style="background-color: rgba(0,0,0,.5);border-radius: 5px;position:absolute;" flex="main:center cross:center">
      <div>
        <img :src="path+'static/images/pc/tip.png'" style="display: inline-block;width:23px;height:23px;margin-left:25px;">
        <div id="" style="text-align: left;display: inline-block;color:white;margin-right:22px;">{{info_err}}</div>
      </div>
    </v-drawer>

  </div>

</template>

<script>
  import mAlert from './mAlert';
  import vDrawer from './drawer';
  import md5 from 'js-md5';
  export default {
    name: "info",
    components: {
      mAlert,
      vDrawer
    },
    data() {
      return {
        success: false,
        IsTestDrive: false,
        choose_province: false,
        choose_dealer: false,
        choose_city: false,
        showStoreDetail: false,
        showAddress: false,
        min: false,
        dforms: {
          userName: '',
          phoneNbr: '',
          gender: '1',
          clueType: '2',
          CarSeries: '22',
          city: '选择城市',
          cityName: '选择城市',
          province: '选择省份',
          provinceName: '选择省份',
          dealer: '',
          dealerName: '选择专营店',
          clueName: '全新逍客3D配置器',
          clueURL: '',
          Duration: '6',
          departmentID: '6d9d2c92d9f446bbafeca99ef72cf2c0',
          departmentName: '市场部',
          subDepartmentName: '车型科',
          CampaignID: '15f6c4e0-673f-4129-aef8-3ed9e4856e07',
          cluePageID: 1,
          terminalCode: 0,
          siteName: 'nissan',
          smartCode: '',
          cookieID: ''
        },
        layuiStyle: {},
        protocol: '',
        activeOptions: [],
        dealerInfos: [],
        provinces: getConfigure('provice').data,
        CityInfoList: [],
        info_err: "",
        currentDealerInfo: {}
      }
    },
    created(){
      this.ready();
    },
    mounted() {
      let me = this;
      this.$nextTick(function () {
        let inners = document.getElementsByClassName('inner');
        if (window.innerWidth > 1023) {
          let H = document.getElementsByClassName('main-page-container')[0].clientHeight - (document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('protocol')[0].clientHeight - document.getElementsByClassName('test_drive')[0].clientHeight);
          let H1 = document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('book_wrap')[0].clientHeight + document.getElementsByClassName('group')[0].clientHeight * 2;
          // console.log(document.getElementsByClassName('main-page-container')[0].clientHeight,document.getElementsByClassName('car-base')[0].clientHeight)
          if (H1 > H) {
            this.min = true;
          }
          // menu.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
          for (let i = 0; i < inners.length; i++) {
            let inner = inners[i];
            inner.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
          }
        } else {
          let H = document.getElementsByClassName('main-page-container')[0].clientHeight - (document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('box')[0].clientHeight * 2);
          let H1 = document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('book_wrap')[0].clientHeight + document.getElementsByClassName('group')[0].clientHeight * 2;
          if (H1 < H) {
            this.min = true;
          }
          // menu.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
          for (let i = 0; i < inners.length; i++) {
            let inner = inners[i];
            inner.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
          }
        }
      })
      this.dforms.clueURL = this.setClubUrl();
      this.dforms.cookieID = this.getCookie("sc_ext_contact");
      this.dforms.smartCode = this.getQueryString('SMARTCODE');

      let carType = window.UrlValue("car");
      switch (carType) {
        case "qashqai":
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '22';
          break;
        case "sylphy":
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '13';
          break;
        case 'altima':
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '51';
          break;
        case "kicks":
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '40';
          break;
        case "lannia":
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '14';
          break;
        case 'murano':
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '23';
          break;
        case "sylphy-classic":
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '16';
          break;
        case "sylphyev":
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '49';
          break;
        case 'terra':
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '48';
          break;
        case 'tiida':
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '6';
          break;
        case 'x-trail':
          this.dforms.clueName = '在线3D看车';
          this.dforms.CampaignID = 'bf037fa2-b4c9-416f-a831-33356ba9df94';
          this.dforms.CarSeries = '21';
          break;
      }

      // console.log(this.getQueryString('SMARTCODE'))
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
        this.dforms.terminalCode = 1;
      }
      document.addEventListener('click', function (e) {

        if (e.target.className.indexOf('filter-option') == -1) {
          if (me.choose_dealer) {
            me.choose_dealer = false;
          }
          if (me.choose_city) {
            me.choose_city = false;
          }
          if (me.choose_province) {
            me.choose_province = false;
          }
        }
      })
    },
    methods: {
      getQueryString(name) {
        if (window != parent) {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(document.referrer) || [, ""])[1].replace(/\+/g, '%20')) || null
        }
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.parent.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
      clickYinshi(){
        ha('send','action','drive_'+cartype.replace('-','')+'_privacy_policy');
        this.$refs.alert.show();
      },
      // setCookie(name,value)
      // {
      //   var Days = 30;
      //   var exp = new Date();
      //   exp.setTime(exp.getTime() + Days*24*60*60*1000);
      //   document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
      // },
      getCookie(name) {
        // console.log(window.parent.document.cookie)
        let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        let cookies = document.cookie;
        // if(window != parent){
        //   cookies = window.parent.document.cookie;
        // }
        if (arr = cookies.match(reg)) {
          let cookieArr = arr[2].split('|');
          let cookieID = cookieArr[0]
          return cookieID;
        } else
          return null;
      },
      setClubUrl() {
        let clueURL = '';
        if (window != parent) {
          clueURL = document.referrer;
        } else {
          clueURL = window.parent.location.href
        }
        let clueArr = clueURL.split("?");
        let clueURL_full = "";
        // 链接如果没有"?"
        if (clueArr.length <= 1) {
          let wellNum = window.location.hash.split("#");
          if (wellNum.length <= 1) {
            clueURL_full = clueURL
          } else {
            let urlHref = clueURL;
            urlHref = urlHref.split("#");
            clueURL_full = urlHref[0] + "%23" + encodeURIComponent(urlHref[1])
          }
        } else { //参数"?"前面有"#"要编码
          clueURL_full = clueArr[0].replace("#", "%23") + "?" + encodeURIComponent(clueArr[1])
        }
        return clueURL_full;
      },
      submitBtn() {
        ha('send','action','drive_'+cartype.replace('-','')+'_submit_appointment');
        if (this.dforms.userName === '') {

          this.info_err = '请输入您的姓名！';
          this.$refs.drawer.show();
          return false
        }
        if (this.dforms.phoneNbr === '') {
          this.info_err = '请输入手机号码！';
          this.$refs.drawer.show();
          return false
        } else if (!(/^1[3456789]\d{9}$/.test(this.dforms.phoneNbr))) {
          this.info_err = '请填写正确的手机号码！';
          this.$refs.drawer.show();
          return false;
        }
        if (this.dforms.province === '' || this.dforms.province === '选择省份') {
          this.info_err = '请选择省份！';
          this.$refs.drawer.show();
          return false
        }
        if (this.dforms.city === '' || this.dforms.city === '选择城市') {
          this.info_err = '请选择省市！';
          this.$refs.drawer.show();
          return false
        }

        if (this.dforms.dealer === '' || this.dforms.dealer === '选择专营店') {
          this.info_err = '请选择专营店！';
          this.$refs.drawer.show();
          return false
        }

        if (this.protocol != true) {
          this.info_err = '请阅读隐私条款！';
          this.$refs.drawer.show();
          return false
        }

        if(this.$store.state.config.car != '逍客'){
          ha("send", "action", "cardrive_btn", {
            "gender1": this.dforms.gender,
            "province1": this.dforms.provinceName,
            "city1": this.dforms.cityName,
            "dealer1": this.dforms.dealerName
          });
        }else{
          ha("send`", 'action', 'test_drive');
          ha("send", "action", "cardrive_btn", {
            "gender1": this.dforms.gender,
            "province1": this.dforms.provinceName,
            "city1": this.dforms.cityName,
            "dealer1": this.dforms.dealerName
          });
        }
        delete this.dforms.dealerName;
        delete this.dforms.provinceName;
        delete this.dforms.cityName;

        let string = "";
        if (this.$store.state.config.options.length > 0) {
          let arr = [];
          this.$store.state.config.options.forEach(it => {
            arr.push(it.name)
          })
          string = arr.join('');
          string+= ';';
          this.dforms.clueDetails ='车型:'+this.$store.state.config.car+';版本:' + this.$store.state.config.carName+';颜色:' + this.$store.state.config.outColor + ';内饰:' + this.$store.state.config.innerColor + ';精品:' + string;
        }else{
          this.dforms.clueDetails ='车型:'+this.$store.state.config.car+';版本:' + this.$store.state.config.carName+';颜色:' + this.$store.state.config.outColor.trim() + ';内饰:' + this.$store.state.config.innerColor+';';
        }

        this.dforms.clueDetails = this.dforms.clueDetails.replace(/\s*/g,"");

        this.$http.post('https://api.dongfeng-nissan.com.cn/api/Nissan/SaveClue', this.dforms).then(res => {
          if (res.data.success) {

            this.success = true;
            ha('send','action','drive_'+cartype.replace('-','')+'_submit_appointment_done',res.data.data.clueID);
            this.$emit('hideBtn');
            stm_clicki('send', 'event', {
              customActionId: 8,
              customActionLabel1: res.data.data.clueID,
              customActionLabel2: this.$store.state.config.car,
              customActionLabel3: md5(md5(this.dforms.userName)),
              customActionLabel4: this.dforms.gender==1?"男":"女",
              customActionLabel5: md5(md5(this.dforms.phoneNbr)),
              customActionLabel6: this.dforms.provinceName,
              customActionLabel7: this.dforms.cityName,
              customActionLabel8: this.dforms.dealerName,
            });
          }
        })
      },
      showAll(data, e) {
        if (e && e.stopPropagation)
          //因此它支持W3C的stopPropagation()方法
          e.stopPropagation();
        else {
          //否则，我们需要使用IE的方式来取消事件冒泡
          window.event.cancelBubble = true;
        }

        this.$nextTick(function () {
          let inners = document.getElementsByClassName('inner');
          if (window.innerWidth > 1023) {
            let H = document.getElementsByClassName('main-page-container')[0].clientHeight - (document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('protocol')[0].clientHeight - document.getElementsByClassName('test_drive')[0].clientHeight);
            let H1 = document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('book_wrap')[0].clientHeight + document.getElementsByClassName('group')[0].clientHeight * 2;
            // console.log(H,H1)
            if (H1 > H) {
              this.min = true;
            }
            // menu.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
            for (let i = 0; i < inners.length; i++) {
              let inner = inners[i];
              inner.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
            }
          } else {
            let H = document.getElementsByClassName('main-page-container')[0].clientHeight - (document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('box')[0].clientHeight * 2);
            let H1 = document.getElementsByClassName('car-base')[0].clientHeight - document.getElementsByClassName('book_wrap')[0].clientHeight + document.getElementsByClassName('group')[0].clientHeight * 2;
            if (H1 < H) {
              this.min = true;
            }
            // menu.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
            for (let i = 0; i < inners.length; i++) {
              let inner = inners[i];
              inner.style.maxHeight = H > H1 ? H + 'px' : H1 + 'px';
            }
          }
        })
        // this.$nextTick(() => {
        //   let basic = parseFloat(document.documentElement.style.fontSize.split('px')[0]).toFixed(2);
        //   let height = document.getElementById('app').clientHeight - e.target.getBoundingClientRect().top - e.target.getBoundingClientRect().height - 0.9 * basic - e.target.getBoundingClientRect().height + 'px';
        //   if (e.target.className.indexOf('caret') != -1 && e.target.className.indexOf('bs-caret') == -1) {
        //     e.target.parentElement.parentElement.nextElementSibling.childNodes[0].parentElement.style.maxHeight = height;
        //   } else if (e.target.className.indexOf('dropdown-toggle') != -1) {
        //     e.target.nextElementSibling.childNodes[0].parentElement.style.maxHeigh = height;
        //   } else {
        //     e.target.parentElement.nextSibling.nextElementSibling.childNodes[0].parentElement.style.maxHeight = height;
        //   }
        // });
        // console.log(e.target.parentElement.parentElement.nextSibling.nextElementSibling)
        // console.log(e.target.getBoundingClientRect())
        // console.log(document.getElementById('app').clientHeight,e.target.getBoundingClientRect().top,0.9 * basic,e.target.getBoundingClientRect().height)
        // console.log(document.getElementById('app').clientHeight - e.target.getBoundingClientRect().top  - 0.9 * basic - e.target.getBoundingClientRect().height);
        // e.target.parentElement.nextSibling.nextElementSibling.style.maxHeight = document.getElementById('app').clientHeight - e.target.getBoundingClientRect().top - e.target.getBoundingClientRect().height - 0.9 * basic - e.target.getBoundingClientRect().height + 'px';
        if (data === 1) {
          this.choose_province = !this.choose_province;
          this.choose_city = false;
          this.choose_dealer = false;
        }
        if (data === 2) {
          this.$http.post('https://api.dongfeng-nissan.com.cn/api/Nissan/GetNissanCity', {
            provinceId: this.dforms.province
          }).then(res => {
            if (res.data.success) {
              this.CityInfoList = res.data.data.CityInfoList;
            }
          })
          this.choose_city = !this.choose_city;
          this.choose_dealer = false;
          this.choose_province = false
        }
        if (data === 3) {
          this.$http.post('https://api.dongfeng-nissan.com.cn/api/Nissan/GetNissanDealers', {
            province: this.dforms.provinceName,
            city: this.dforms.cityName,
            cbbIds: JSON.stringify([getConfigure('carVersion').cid])
          }).then(res => {
            if (res.data.success) {
              this.dealerInfos = res.data.data.DealerInfos;
            }
          })
          this.choose_dealer = !this.choose_dealer;
          this.choose_province = false;
          this.choose_city = false
        }
      },
      mouseover(data, index) {
        this.showStoreDetail = true;
        this.showAddress = false;
        this.currentDealerInfo = data;
        this.currentDealerInfo.index = index;
      },
      choiceProvince(data, data1) {
        this.choose_province = false;
        if (this.dforms.province != data1.id) {
          this.dforms.province = data1.id;
          this.dforms.provinceName = data1.name;
          this.dforms.city = '';
          this.dforms.cityName = '选择城市';
          this.dforms.dealer = '';
          this.dforms.dealerName = '选择专营店';
          this.showAddress = false;
        } else {
          return
        }
      },

      choiceCity(city) {
        this.choose_city = false;
        if (this.dforms.city != city.ID) {
          this.dforms.cityName = city.Name;
          this.dforms.city = city.ID;
          this.dforms.dealerName = '选择专营店';
          this.dforms.dealer = '';
          this.showAddress = false;
        } else {
          return;
        }
      },
      choiceDealer(dealer) {
        this.choose_dealer = false;
        this.showAddress = true;
        this.dforms.dealer = dealer.StoreID;
        this.dforms.dealerName = dealer.StoreName;
      },
      ready() {
        let me = this;
        let geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition((result) => {
          let province = result.address.province.split('省')[0];
          let city = result.address.city.split('市')[0];
          if(this.dforms.city != '选择城市'){
            return;
          }
          try {
            me.provinces.forEach(it => {
              if (it.name === province) {
                me.dforms.province = it.id;
                me.dforms.provinceName = it.name;
                me.$http.post('https://api.dongfeng-nissan.com.cn/api/Nissan/GetNissanCity', {
                  provinceId: it.id
                }).then(res => {
                  if (res.data.success) {
                    me.CityInfoList = res.data.data.CityInfoList;
                    try {
                      me.CityInfoList.forEach(it => {
                        if (it.Name === city) {
                          me.choiceCity(it);
                          throw Error();
                        }
                      })
                    } catch (e) {

                    }

                  }
                })
                throw Error();
              }
            })
          } catch (e) {

          }
          // this.city= r.address.city;

        }, {enableHighAccuracy: true})
      }
    }
  }
</script>

<style lang="scss">
@import "../assets/css/aa.css";
</style>
